import { NgModule } from "@angular/core";
import { InputGridFunctionsFormComponent } from './input-grid-functions-form/input-grid-functions-form.component';
import { DynamicInputGridFunctionsComponent } from './dynamic-input-grid-functions.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { IonicModule } from '@ionic/angular';
import { CommonModule } from '@angular/common';
import { InputGridFunctionsDesignComponent } from './input-grid-functions-design/input-grid-functions-design.component';
import { InputGridFunctionsResultComponent } from './input-grid-functions-result/input-grid-functions-result.component';
import { MaterialModule } from '../../material.module';
import { KendoModule } from '../kendo.module';
import { InputGridFunctionsFiltersComponent } from './input-grid-functions-filters/input-grid-functions-filters.component';
import { DynamicInputGridFunctionsFiltersComponent } from './input-grid-functions-filters/dynamic-input-grid-functions-filters.component';
import { ExpressionBuilderModule } from '../expression-builder/expression-builder.module';
import { InputMaskModule } from '@ngneat/input-mask';

@NgModule({
    declarations: [
        InputGridFunctionsResultComponent,
        InputGridFunctionsDesignComponent,
        InputGridFunctionsFormComponent, DynamicInputGridFunctionsComponent,
        InputGridFunctionsFiltersComponent, DynamicInputGridFunctionsFiltersComponent
    ],
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        IonicModule,
        MaterialModule,
        KendoModule,
        ExpressionBuilderModule,
        InputMaskModule
    ],
    entryComponents: [
        DynamicInputGridFunctionsComponent,
        DynamicInputGridFunctionsFiltersComponent
    ]
})
export class InputGridFunctionsModule {}